export function queryString (obj) {
  const params = []
  for (let k in obj) {
    params.push(`${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`)
  }
  if (params.length === 0) {
    return ''
  }
  return params.join('&').replace(/%20/g, '+')
}
export function params2QueryString (url, obj) {
  const paramsStr = queryString(obj)
  const i = url.indexOf('?')
  return `${url}${i > 0 ? '&' : '?'}${paramsStr}`
}



// WEBPACK FOOTER //
// ./src/packages/utils/qs.js